var _g, _rect, _g2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideokyc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 69,
    viewBox: "0 0 105 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_71_274)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 67,
    rx: 5,
    fill: "#FCF7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 102,
    height: 66,
    rx: 4.5,
    stroke: "#6B4C7C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_71_274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 101,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 101,
    height: 65,
    rx: 4,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_71_274)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.1667 21.125H60.3334C59.875 21.125 59.5 21.5 59.5 21.9583C59.5 22.4167 59.875 22.7917 60.3334 22.7917H66.1667C66.625 22.7917 67 23.1667 67 23.625V41.125C67 41.5833 66.625 41.9583 66.1667 41.9583H62V37.7917C62 34.575 59.3834 31.9583 56.1667 31.9583H47.8334C44.6167 31.9583 42 34.575 42 37.7917V41.9583H37.8334C37.375 41.9583 37 41.5833 37 41.125V23.625C37 23.1667 37.375 22.7917 37.8334 22.7917H43.6667C44.125 22.7917 44.5 22.4167 44.5 21.9583C44.5 21.5 44.125 21.125 43.6667 21.125H37.8334C36.4584 21.125 35.3334 22.25 35.3334 23.625V41.125C35.3334 42.5 36.4584 43.625 37.8334 43.625H66.1667C67.5417 43.625 68.6667 42.5 68.6667 41.125V23.625C68.6667 22.25 67.5417 21.125 66.1667 21.125ZM43.6667 41.9583V37.7917C43.6667 35.4917 45.5334 33.625 47.8334 33.625H56.1667C58.4667 33.625 60.3334 35.4917 60.3334 37.7917V41.9583H43.6667Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3334 46.125H50.3334C50.2834 46.125 50.2417 46.1417 50.1917 46.15C49.8584 45.1667 48.9334 44.4583 47.8334 44.4583C46.7334 44.4583 45.8167 45.175 45.475 46.15C45.425 46.1417 45.3834 46.125 45.3334 46.125H38.6667C38.2084 46.125 37.8334 46.5 37.8334 46.9583C37.8334 47.4167 38.2084 47.7917 38.6667 47.7917H45.3334C45.3834 47.7917 45.425 47.775 45.475 47.7667C45.8084 48.75 46.7334 49.4583 47.8334 49.4583C48.9334 49.4583 49.85 48.7417 50.1917 47.7667C50.2417 47.775 50.2834 47.7917 50.3334 47.7917H65.3334C65.7917 47.7917 66.1667 47.4167 66.1667 46.9583C66.1667 46.5 65.7917 46.125 65.3334 46.125ZM47.8334 47.7917C47.375 47.7917 47 47.4167 47 46.9583C47 46.5 47.375 46.125 47.8334 46.125C48.2917 46.125 48.6667 46.5 48.6667 46.9583C48.6667 47.4167 48.2917 47.7917 47.8334 47.7917Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30.7083C55.9083 30.7083 59.0833 27.5333 59.0833 23.625C59.0833 19.7167 55.9083 16.5417 52 16.5417C48.0916 16.5417 44.9166 19.7167 44.9166 23.625C44.9166 27.5333 48.0916 30.7083 52 30.7083ZM52 18.2083C54.9833 18.2083 57.4166 20.6417 57.4166 23.625C57.4166 26.6083 54.9833 29.0417 52 29.0417C49.0166 29.0417 46.5833 26.6083 46.5833 23.625C46.5833 20.6417 49.0166 18.2083 52 18.2083Z",
    fill: "#282828"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_71_274",
    x: 0,
    y: 0,
    width: 105,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.871272 0 0 0 0 0.871272 0 0 0 0 0.871272 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_71_274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_71_274",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideokyc);
export default __webpack_public_path__ + "static/media/videokyc.a7fd2759288095c2af6b8553d9a8ce2d.svg";
export { ForwardRef as ReactComponent };